<div style="position: relative;">
  <video #video style="position: fixed; opacity: 0.2;"></video>
  <div id="mmd-wrapper" style="position: absolute; width: 100vw; height: 100vh; left:0; right:0;"></div>
  
  <canvas #vrmCanvas></canvas>
</div>
